import { ToolWidgetType, TreeWidgetType, WidgetType, WidgetTypeWithSuffix } from './widgetType'

/**
 * Used by `react-dnd` to identify the type of drag event
 */
export const MosaicDragType = {
  WINDOW: 'MosaicWindow',
  WIDGET_BUTTON: 'WidgetButton',
  TREE_ITEM: 'TreeItem',
} as const

/**
 * Used to communicate information from the different drag  targets
 */
export type BaseMosaicDragItem = {
  mosaicId: string
}

export type MosaicDragItem = 
| (BaseMosaicDragItem & { type: typeof MosaicDragType.WINDOW; widgetType: WidgetType; hideTimer: number })
| (BaseMosaicDragItem & { type: typeof MosaicDragType.WIDGET_BUTTON; widgetType: ToolWidgetType; index: number })
| (BaseMosaicDragItem & { type: typeof MosaicDragType.TREE_ITEM; widgetType: TreeWidgetType; itemId: WidgetTypeWithSuffix });
